// Sourcing avatar from /assets folder
import photo from "../assets/photo.jpg";

// Type definitions for the crew data object
export interface CrewDataTypes {
  id: number;
  avatar: string;
  firstName: string;
  lastName: string;
  email: string,
  phone: string,
  website: string,
  department: string;
  jobsCompleted: number,
  lastAssigned: string,
  rating: number;
  availability: string;
}

// Array of crew data objects
export const crewData: CrewDataTypes[] = [
  {
    id: 1,
    avatar: photo,
    firstName: "Clyde",
    lastName: "Mataga",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Videographer",
    jobsCompleted: 7,
    lastAssigned: "12-09-2025",
    rating: 4.3,
    availability: "available",
  },
  {
    id: 2,
    avatar: photo,
    firstName: "Sarah",
    lastName: "Chen",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Photographer",
    jobsCompleted: 12,
    lastAssigned: "23-07-2025",
    rating: 3.7,
    availability: "available",
  },
  {
    id: 3,
    avatar: photo,
    firstName: "Marcus",
    lastName: "Johnson",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Audio Engineer",
    jobsCompleted: 11,
    lastAssigned: "15-09-2024",
    rating: 4.1,
    availability: "busy",
  },
  {
    id: 4,
    avatar: photo,
    firstName: "Elena",
    lastName: "Rodriguez",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Editor",
    jobsCompleted: 9,
    lastAssigned: "20-10-2025",
    rating: 4.9,
    availability: "available",
  },
  {
    id: 5,
    avatar: photo,
    firstName: "James",
    lastName: "O'Brien",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Camera Operator",
    jobsCompleted: 7,
    lastAssigned: "01-05-2025",
    rating: 2.3,
    availability: "busy",
  },
  {
    id: 6,
    avatar: photo,
    firstName: "Priya",
    lastName: "Patel",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Production Manager",
    jobsCompleted: 65,
    lastAssigned: "24-12-2024",
    rating: 3.1,
    availability: "available",
  },
  {
    id: 7,
    avatar: photo,
    firstName: "David",
    lastName: "Kim",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Lighting Technician",
    jobsCompleted: 23,
    lastAssigned: "25-01-2025",
    rating: 4.5,
    availability: "busy",
  },
  {
    id: 8,
    avatar: photo,
    firstName: "Amara",
    lastName: "Okonkwo",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Director",
    jobsCompleted: 34,
    lastAssigned: "13-04-2023",
    rating: 3,
    availability: "busy",
  },
  {
    id: 9,
    avatar: photo,
    firstName: "Lucas",
    lastName: "Martinez",
    email: "mail@mail.com",
    phone: "+263 71 234 5678",
    website: "muzukuru.co.zw",
    department: "Colorist",
    jobsCompleted: 6,
    lastAssigned: "10-12-2025",
    rating: 4.6,
    availability: "available",
  }
];

export interface CrewActivityDataTypes {
  id: number;
  type: "checkedin" | "notcheckedin" | "completed" | "rating";
  user: string;
  message: string;
  time: string;
  icon: "success" | "warning" | "info";
}

// Array of crew activities
export const activities: CrewActivityDataTypes[] = [
  {
    id: 1,
    type: "checkedin",
    user: "Tinashe",
    message: "checked in at Old Mutual Chapel.",
    time: "08:45 AM",
    icon: "info",
  },
  {
    id: 2,
    type: "notcheckedin",
    user: "Jaheed",
    message: "hasn't checked in for the Glen Norah stream.",
    time: "10:45 AM",
    icon: "warning",
  },
  {
    id: 3,
    type: "rating",
    user: "Jon Jones",
    message: "4.8 star rating submitted.",
    time: "11:25 AM",
    icon: "info",
  },
  {
    id: 4,
    type: "completed",
    user: "Xherdan Shaqiri",
    message: "completed their gig & has checked out.",
    time: "11:25 AM",
    icon: "info",
  },
];

export interface StreamsPendingAssignmentsDataTypes {
  id: string;
  title: string;
  crewNeeded: number;
  priority: "high" | "low";
  location: string;
  date: string;
}

// Array of streams pending assignments
export const streamsPendingAssignments: StreamsPendingAssignmentsDataTypes[] = [
  {
    id: "1",
    title: "Leon Goretzka Memorial",
    crewNeeded: 4,
    priority: "high",
    location: "Sacred Heart Cathedral",
    date: "12 Dec 2025",
  },
  {
    id: "2",
    title: "George Best Burial",
    crewNeeded: 2,
    priority: "low",
    location: "Holy Chapel",
    date: "24 Nov 2025",
  },
];

export interface crewPaymentsDataTypes {
  id: number;
  user: string;
  date: string;
  amount: number;
}

// Array of crew payments
export const crewPayments: crewPaymentsDataTypes[] = [
  {
    id: 1,
    user: "Leon Goretzka Memorial",
    date: "12 Dec 2025",
    amount: 34,
  },
  {
    id: 2,
    user: "George Best Burial",
    date: "24 Nov 2025",
    amount: 50,
  },
  {
    id: 3,
    user: "The Memorial",
    date: "28 Jan 2026",
    amount: 15,
  },
];
